export const LINKEDINURL = "https://www.linkedin.com/in/leonardtan13/"
export const GITHUBURL = "https://github.com/leonardtan13"
export const EMAIL = "mailto:leonardtan13@gmail.com"
export const RESUME = "https://drive.google.com/file/d/1wp8G5tVdKXSwZyIUdux3kC-pvIXKGuL1/view?usp=sharing"


